import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Button } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { faCircle } from "@fortawesome/free-regular-svg-icons";

const Datasets = ({
  datasetsList,
  datasetsRelationships,
  datasets,
  setDatasets,
}) => {
  const [availableDatasets, setAvailableDatasets] = useState([]);

  const onlyUnique = (value, index, self) => {
    return self.indexOf(value) === index;
  };

  const getParents = ({ list }) => {
    return list
      .reduce((acc, id) => {
        const match = availableDatasets.find((setDetail) => {
          return setDetail.datasetid === id;
        });

        if (match) {
          return [...acc, ...match.parent];
        }

        return acc;
      }, [])
      .filter((value) => !!value)
      .filter(onlyUnique);
  };

  const reset = () => {
    return datasetsList.map((item) => {
      return {
        parent: [],
        datasetid: item.id,
      };
    });
  };

  const toggleSelectedDataset = (id) => {
    if (!datasetsRelationships?.[id]) {
      return;
    }
    let list = [...datasets];

    if (list.includes(id)) {
      list = list.filter((value) => {
        return value !== id;
      });
    } else {
      list.push(id);
    }

    if (list.length > 0) {
      const parents = getParents({ list });

      if (parents.length > 0) {
        list = filterDatasetParentInSelectedList({ list });
      }

      if (list.length > 0) {
        let availables = [];
        list.forEach((item) => {
          const items = datasetsRelationships[item].map((dataSet) => {
            return {
              parent: [item],
              datasetid: dataSet,
            };
          });
          availables = items.reduce((acc, dataSet) => {
            const index = acc.findIndex((setDetail) => {
              return setDetail.datasetid === dataSet.datasetid;
            });

            if (index !== -1 && !dataSet.parent.includes(dataSet.datasetid)) {
              acc[index].parent = [...acc[index].parent, ...dataSet.parent];
            } else if (index === -1) {
              acc.push(dataSet);
            }

            return acc;
          }, availables);
        });

        setAvailableDatasets(availables);
      } else {
        setAvailableDatasets(reset());
      }
    } else {
      setAvailableDatasets(reset());
    }
    setDatasets(list);
  };

  const filterDatasetParentInSelectedList = ({ list }) => {
    return list.filter((selectedItem) => {
      const match = availableDatasets.find((setDetail) => {
        return setDetail.datasetid === selectedItem;
      });

      if (match) {
        return match.parent.some((id) => {
          return list.includes(id);
        });
      }

      return true;
    });
  };

  useEffect(() => {
    if (datasetsList) {
      const items = reset();
      setAvailableDatasets(items);
    }
  }, [datasetsList]);

  useEffect(() => {
    if (datasets?.length > 0) {
      let availables = [];
      datasets.forEach((id) => {
        if (!datasetsRelationships[id]) {
          return;
        }
        const items = datasetsRelationships[id].map((dataSet) => {
          return {
            parent: [id],
            datasetid: dataSet,
          };
        });
        availables = items.reduce((acc, dataSet) => {
          const index = acc.findIndex((setDetail) => {
            return setDetail.datasetid === dataSet.datasetid;
          });

          if (index !== -1 && !dataSet.parent.includes(dataSet.datasetid)) {
            acc[index].parent = [...acc[index].parent, ...dataSet.parent];
          } else if (index === -1) {
            acc.push(dataSet);
          }

          return acc;
        }, availables);
      });
      setAvailableDatasets(availables);
    }
  }, [datasets]);

  return (
    <div className="builder__datasets">
      <ul className="list-inline">
        {datasetsList &&
          datasetsList.map((item) => (
            <li key={item.id} className="list-inline-item">
              <Button
                color="primary"
                outline={!datasets.includes(item.id)}
                onClick={() => toggleSelectedDataset(item.id)}
                disabled={
                  !availableDatasets.find(
                    (availableItem) => availableItem.datasetid === item.id
                  )
                }
                data-id={item.id}
              >
                <FontAwesomeIcon
                  icon={datasets.includes(item.id) ? faCheckCircle : faCircle}
                  className="me-2"
                />
                {item.title}
              </Button>
            </li>
          ))}
      </ul>
    </div>
  );
};

Datasets.propTypes = {
  datasetsList: PropTypes.array,
  datasetsRelationships: PropTypes.object,
  datasets: PropTypes.array.isRequired,
  setDatasets: PropTypes.func.isRequired,
};

Datasets.defaultProps = {
  datasetsList: null,
  datasetsRelationships: null,
};

export default Datasets;
